import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=540ac6ff&"
import script from "./autocomplete.vue?vue&type=script&lang=js&"
export * from "./autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete.vue?vue&type=style&index=0&id=540ac6ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports